import {
	NestedCheckBoxButton,
	NestedCheckBoxInnerContainer,
	NestedCheckboxInnerWrapper,
	NestedCheckboxWrapper,
} from '@dealstack/frontend/shared/components/forms/SearchSelectWithNestedCollapsableChildren/styled';
import { showCaretIcon } from '@dealstack/frontend/shared/components/forms/SearchSelectWithNestedCollapsableChildren/utils';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { Checkbox } from '@mantine/core';
import { SearchSelectWithNestedCollapsableChildrenOptions } from './SearchSelectWithNestedCollapsableChildren.types';

export const NestedCheckboxes = (
	data: SearchSelectWithNestedCollapsableChildrenOptions[],
	selected: Set<string>,
	expanded: string[],
	onToggleSelection: (value: string) => void,
	onToggleExpand: (label: string) => void,
	level = 0
) => {
	return data.map((item) => (
		<NestedCheckboxWrapper key={item.value} level={level}>
			<NestedCheckBoxInnerContainer>
				<Checkbox
					label={item.label}
					checked={selected.has(item.value.toString() ?? '')}
					onChange={() => onToggleSelection(item.value.toString() ?? '')}
					style={{ flex: 1 }}
					size="xs"
					disabled={item?.disabled}
				/>
				{item?.children && item.children.length > 0 && (
					<NestedCheckBoxButton
						onClick={() => onToggleExpand(item.label)}
						data-testid="nested-checkbox-button"
					>
						<Icon variant={showCaretIcon(expanded, item.label)} size="lg" />
					</NestedCheckBoxButton>
				)}
			</NestedCheckBoxInnerContainer>
			{item?.children && item.children.length > 0 && expanded.includes(item.label) && (
				<NestedCheckboxInnerWrapper>
					{NestedCheckboxes(
						item.children,
						selected,
						expanded,
						onToggleSelection,
						onToggleExpand,
						level + 1
					)}
				</NestedCheckboxInnerWrapper>
			)}
		</NestedCheckboxWrapper>
	));
};
